import { TimelineMax, Linear } from 'gsap'

export default {
  data () {
    return {
      tlDay: new TimelineMax({ paused: true })
    }
  },

  mounted () {
    this.tlDay
      .add('start')
      .to('.cloud1', 45, {
        x: '-200%',
        ease: Linear.easeNone,
        repeat: -1
      }, 'start += ' + Math.floor(Math.random() * 5))
      .to('.cloud2', 50, {
        x: '-200%',
        ease: Linear.easeNone,
        repeat: -1
      }, 'start += ' + Math.floor(Math.random() * 5))
      .to('.cloud3', 55, {
        x: '-200%',
        ease: Linear.easeNone,
        repeat: -1
      }, 'start += ' + Math.floor(Math.random() * 5))
      .to('.cloud4', 70, {
        x: '-200%',
        ease: Linear.easeNone,
        repeat: -1
      }, 'start += ' + Math.floor(Math.random() * 5))
      .to('.ring', 1.5, {
        scale: 1.1,
        transformOrigin: '50% 50%',
        repeat: -1,
        yoyo: true,
        ease: Linear.easeNone
      }, 'start')
  },
  beforeDestroy () {
    this.tlDay.kill()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/day.js